import React, { useEffect, useState } from "react";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useLocation, useNavigate } from "react-router-dom";
import { createQuotation } from "../../../services/apiService";
import { showSuccessToast } from "../../../utils/toastUtils";

const PreviewQuotation = ({
  clientName,
  ots,
  wallets,
  profileData,
  reportData,
}) => {
  // const handlePrint = async () => {
  //   console.log("print clicked");

  //   const pages = document.querySelectorAll(".page-break");
  //   const pdf = new jsPDF("p", "mm", "a4");

  //   for (let i = 0; i < pages.length; i++) {
  //     const canvas = await html2canvas(pages[i], {
  //       scale: 2,
  //       useCORS: true,
  //     });

  //     const imgData = canvas.toDataURL("image/png");

  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  //     if (i !== 0) pdf.addPage();

  //     pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  //   }

  //   pdf.save("quotation.pdf");
  // };

  //   const { state } = useLocation();

  //   const { clientName, ots, wallets, profileData, reportData } = state || {};

  //   const handlePrint = async () => {
  //     const payload = {
  //       quotations: reportData?.map((item) => ({
  //         service_id: item.service_id,
  //         billing_type: item.billing_type,
  //         user_id: profileData?.id,
  //         company_client_name: clientName,
  //         packages: item?.packages,
  //         wallets: item?.wallets,
  //         system_prices: item?.system_prices,
  //         final_prices: item?.wallets,
  //         one_time_setup_fee: ots,
  //       })),
  //     };
  //     console.log(payload);

  //     try {
  //       const res = await createQuotation(payload);

  //       if (res?.status?.code === 200 || res?.data?.status?.code === 200) {
  //         showSuccessToast(
  //           res?.data?.message || res?.data?.data?.message || res?.message,
  //         );
  //       }
  //     } catch (error) {
  //       console.log(error);
  //     }
  //     window.print();
  //   };
  const navigate = useNavigate();

  const handleRedirect = async () => {
    navigate("/QuotationPreview", {
      state: {
        clientName,
        ots,
        wallets,
        profileData,
        reportData,
      },
    });
  };

  const maxPlans = Math.max(
    ...reportData.map((item) => item?.system_prices?.length || 0),
  );

  useEffect(() => {
    console.log(maxPlans);
  }, [maxPlans]);

  return (
    <div
      // style={{ WebkitFontSmoothing: "antialiased" }}
      // id="pdf-content"
      className="bg-gray-100 py-10 min-h-screen font-sans"
    >
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&display=swap');
          @media print {
            .page-break { page-break-after: always; }
            body { background: white; padding: 0; }
            .container-shadow { box-shadow: none !important; border: 1px solid #e5e7eb; }
            .no-print { display: none; }
          }
        `}
      </style>

      {/* PAGE 1 */}
      <div className="max-w-[800px] mx-auto bg-white shadow-2xl mb-10 container-shadow page-break overflow-hidden">
        {/* Hero Section */}
        <div
          className="relative p-8 text-white overflow-hidden"
          style={{
            background: "linear-gradient(90deg, #020617 0%, #1e293b 100%)",
          }}
        >
          <div className="flex justify-between items-start relative z-10">
            <div className="flex items-center space-x-3">
              {/* <div className="bg-white p-2 rounded-full">
                <div className="w-10 h-10 border-4 border-blue-900 rounded-full flex items-center justify-center text-blue-900 font-black text-xl">
                  I
                </div>
              </div> */}
              <div>
                {/* <h1 className="text-2xl font-black leading-none">IDSPAY</h1>
                <p className="text-[10px] uppercase tracking-tighter">
                  For Business
                </p> */}
                <img
                  src="/assets/img/idspay_logo_log2.png"
                  alt=""
                  className="w-[200px] h-auto"
                />
              </div>
            </div>
            <div className="text-right">
              <h2 className="text-4xl font-black tracking-tighter text-cyan-400">
                THE FUTURE
              </h2>
              <h2 className="text-4xl font-black tracking-tighter">
                IS TECHNOLOGY
              </h2>
            </div>
          </div>
          <div className="flex justify-between mt-12 text-[10px] font-bold text-orange-400 z-10 relative">
            <a
              href="https://apiuser.idspay.in/SignUpForm"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Create API Account
            </a>
            <a
              href="https://idspay.in/api-library"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              API Marketplace
            </a>
            <a
              href="https://idspay.in"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              www.idspay.in
            </a>
          </div>
          {/* Cyber Grid Pattern */}
          <div
            className="absolute bottom-0 left-0 w-full h-24 opacity-20"
            style={{
              backgroundImage: "radial-gradient(#3b82f6 1px, transparent 1px)",
              backgroundSize: "20px 20px",
            }}
          ></div>
        </div>

        {/* Company Name Bar */}
        <div className="bg-blue-800 text-white p-4 px-8 font-bold text-xl">
          Company name:- {clientName}
        </div>

        {/* About Section */}
        <div className="flex min-h-[400px]">
          <div
            className="w-1/3 p-6 text-white font-bold text-xl"
            style={{
              background: "linear-gradient(180deg, #1e3a8a 0%, #172554 100%)",
            }}
          >
            About :
          </div>
          <div className="w-2/3 p-8 text-sm text-gray-800 leading-relaxed">
            <p className="mb-4">
              <strong>IDSPay</strong> is a fast-growing{" "}
              <strong>Fintech & API Service Provider</strong> delivering secure,
              scalable and real-time verification solutions across India having{" "}
              <strong>3000+</strong> Client base (100+ NBFCs).
            </p>
            <p className="font-bold mb-4">We specialize in:</p>
            <ul className="space-y-2 list-disc pl-5">
              <li>
                Identity Verification (KYC, PAN, Aadhaar, Voter ID, Passport,
                Driving License, etc.)
              </li>
              <li>
                Financial Risk Checks (Bank Verification, Mobile to UPI, Udyam,
                GST, CIN, Credit Bureau, etc.)
              </li>
              <li>Address & Geo-Location Validation</li>
              <li>Video KYC (RBI Compliant) + Face API</li>
              <li>Digi Locker Integrations</li>
              <li>
                Background Verification and Fraud Prevention & Many more (200+
                API's).
              </li>
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="border-t border-gray-200 text-sm">
          <div className="flex border-b border-gray-200">
            <div className="w-1/3 bg-blue-900 text-white p-3 px-6 font-bold">
              Phone Number:
            </div>
            <div className="w-2/3 p-3 px-6 text-blue-900 font-semibold">
              {profileData?.mobile_number}
            </div>
          </div>
          <div className="flex border-b border-gray-200">
            <div className="w-1/3 bg-blue-900 text-white p-3 px-6 font-bold">
              Email Address:
            </div>
            <div className="w-2/3 p-3 px-6 text-gray-600">
              {profileData?.email_address}
            </div>
          </div>
          <div className="flex">
            <div className="w-1/3 bg-blue-900 text-white p-3 px-6 font-bold">
              Website:
            </div>
            <div className="w-2/3 p-3 px-6 flex justify-between">
              <a
                href="https://idspay.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline cursor-pointer"
              >
                www.idspay.in
              </a>
              <a
                href="https://idspay.in/api-library"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline cursor-pointer"
              >
                Visit API Marketplace
              </a>
            </div>
          </div>
        </div>
        {/* 
        <div className="p-10 space-y-4">
          <p className="font-bold text-gray-800 italic">
            Products:- Credit verification
          </p>
          <p className="font-bold text-gray-800 text-xs">
            IDSPay Provides one stop solution for multiples Verification API in
            all categories.
          </p>
        </div> */}
      </div>

      {/* PAGE 2 */}
      <div className="max-w-[800px] mx-auto bg-white shadow-2xl p-10 mb-10 container-shadow page-break">
        <table className="w-full border-collapse border border-gray-300 text-[11px]">
          <thead>
            <tr className="bg-blue-400 text-black font-bold uppercase">
              <th className="border border-gray-300 p-2 w-1/4">Category</th>
              <th className="border border-gray-300 p-2 w-1/4">Product Name</th>

              <th colSpan="3" className="border border-gray-300 p-2">
                Per verification Cost (in INR)
              </th>
            </tr>
            <tr className="text-blue-700">
              <th className="border border-gray-300 p-2 underline italic">
                API Category
              </th>
              <th className="border border-gray-300 p-2 underline italic">
                API Name
              </th>
              {/* <th className="border border-gray-300 p-2 italic text-purple-800">
                per / hit
              </th> */}
              {Array.from({ length: maxPlans }).map((_, idx) => (
                <th className="border border-gray-300 p-2">
                  Prising Plan ({idx})
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="text-center font-semibold text-gray-700">
            {reportData?.map((item, i) => (
              <tr className="hover:bg-slate-50 transition">
                <td className="p-4 border border-slate-200 font-bold text-blue-800">
                  {item?.category}
                </td>
                <td className="p-4 border border-slate-200 font-bold text-blue-800">
                  {item?.service_name}
                </td>

                {item?.system_prices?.map((plan, i) => {
                  return (
                    <td
                      key={i}
                      className={`p-4 border border-slate-200  text-center align-middle font-mono font-bold text-green-600 ${item ? "text-green-600" : "text-red-600"}`}
                    >
                      {`₹${plan}`}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>

        <div className="mt-6 text-[11px] font-bold space-y-2">
          <p>One Time Setup: ₹ {ots}/-</p>
          <div className="text-left italic text-gray-400 font-normal">
            -------------------------- OR -------------------------
          </div>
          <p className="text-blue-800 uppercase">
            <div className="flex justify-start mb-2 items-center gap-3">
              Wallets{"-"}
              {wallets?.map((item, idx) => (
                <span key={idx}>{`₹${item}`}</span>
              ))}
            </div>
            <span className="text-gray-500 font-normal italic lowercase">
              As required incase of OTS.
            </span>
          </p>
        </div>

        <div className="mt-8 text-[11px]">
          <p className="text-blue-800 font-bold underline mb-2">Other Terms:</p>
          <ol className="list-decimal pl-4 space-y-2 text-gray-600">
            <li>
              Prices are exclusive of applicable Government levies and taxes.
            </li>
            <li>
              Delivery of the service will be through APIs to be consumed by you
              in your application / website.
            </li>
            <li>
              "Per Transaction" means every request for KYC Validation is called
              through the API. Charges will be levied only for requests with a
              successful response (Status "200" or "422").
            </li>
          </ol>
        </div>

        <div className="mt-10">
          <h3 className="font-black text-lg flex items-center mb-4">
            <span className="mr-2">💡</span> Why work with IDSPay?
          </h3>
          <ul className="space-y-2 font-bold text-sm text-gray-800">
            <li className="flex items-center">
              <span className="text-green-600 mr-2">✓</span> Pan-India API
              Coverage
            </li>
            <li className="flex items-center">
              <span className="text-green-600 mr-2">✓</span> Direct Integration
              with Official Gov Sources
            </li>
            <li className="flex items-center">
              <span className="text-green-600 mr-2">✓</span> High Accuracy &
              Real-Time Validation
            </li>
          </ul>
        </div>
      </div>

      {/* PAGE 3 */}
      <div className="max-w-[800px] mx-auto bg-white shadow-2xl p-10 container-shadow mb-10 page-break">
        <ul className="space-y-3 font-bold text-sm mb-12 text-gray-800">
          <li className="flex items-center">
            <span className="text-green-600 mr-2">✓</span> No Manual Data Entry
            / Zero Paperwork
          </li>
          <li className="flex items-center">
            <span className="text-green-600 mr-2">✓</span> Dedicated Technical &
            Sales Support
          </li>
          <li className="flex items-center">
            <span className="text-green-600 mr-2">✓</span> Fast Integration - Go
            Live in Hours
          </li>
        </ul>

        <div className="flex border border-gray-300 text-sm">
          <div className="w-1/3">
            <div className="bg-blue-900 text-white p-3 font-bold border-b border-gray-300">
              Duration:
            </div>
            <div className="bg-blue-400 p-6 h-32 flex items-center justify-center text-center font-bold text-blue-900 leading-tight">
              Proposal is valid for 3 days from the date of creation.
            </div>
            <div className="bg-blue-800 h-10 border-b border-gray-300"></div>
            <div className="bg-blue-400 h-10"></div>
          </div>
          <div className="w-2/3">
            <div className="bg-blue-900 text-white p-3 font-bold border-b border-gray-300 text-center">
              Scope of Work:
            </div>
            <div className="bg-slate-50 p-8 h-[212px] flex flex-col justify-center">
              <ul className="space-y-2 font-semibold text-gray-700">
                <li className="flex items-start">
                  <span className="mr-2">•</span> Ready-to-use APIs eliminate
                  development time.
                </li>
                <li className="flex items-start">
                  <span class="mr-2">•</span> Quick onboarding and product
                  launch within days.
                </li>
                <li className="flex items-start">
                  <span class="mr-2">•</span> No need to maintain internal tech
                  resources.
                </li>
                <li className="flex items-start">
                  <span className="mr-2">•</span> Pay only for API consumption
                  (per-hit model).
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 border-l-4 border-blue-900 pl-4">
          <p className="text-sm font-bold underline mb-2">Disclaimer:</p>
          <p className="text-[11px] text-gray-500 italic leading-relaxed">
            This document is for the sole use of the intended recipient(s) and
            contains confidential and privileged information. Any unauthorized
            review, use, disclosure, copying, or distribution is strictly
            prohibited.
          </p>
        </div>
         <div className="w-full text-sm mt-14 flex gap-2 justify-end">
          <strong>Proposal Date-</strong>
          {new Date().toLocaleDateString()}
        </div>

        <div className="mt-26 flex flex-col items-center opacity-60">
          <div className="flex items-center space-x-2 grayscale">
            <div className="text-center">
              <img
                src="/assets/img/idspay_logo_log3.png"
                alt=""
                className="w-[150px] h-auto"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Print Button */}
      <div className="text-center mt-10 no-print">
        <button
          type="button"
          onClick={handleRedirect}
          className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-4 rounded-full font-bold shadow-xl transition-all transform hover:scale-105"
        >
          Final preview and print
        </button>
      </div>
    </div>
  );
};

export default PreviewQuotation;
